import { IEcommerceAnswerSchema } from '../types'
import commonStyle from '../../_common/style.module.scss'
import ecStyle from '../style.module.scss'

// card-root class for a preview-hidden product: `hidden` = the shared display:none (what live does),
// `fakeHidden` = the EC washed-out mark (see familyTree.ts markHiddenProducts)
export function hiddenClass(answer: IEcommerceAnswerSchema): string {
  if (answer.hidden) return commonStyle.hidden
  if (answer.fakeHidden) return ecStyle.previewHidden
  return ''
}

// the same washed-out mark on a variant-selector value whose only carriers are preview-hidden children
export function hiddenValueClass(hiddenInPreview: boolean): string {
  return hiddenInPreview ? ecStyle.previewHidden : ''
}

// the results count beside the search condition: how many of a grid's cards are actually drawn. A `hidden`
// card takes the display:none class above, so it is not counted; a `fakeHidden` one is drawn washed out
// ("Show hidden items" on), so it is. Respondents never carry `hidden` (live cuts the product server-side).
export function countDrawnCards(cards: IEcommerceAnswerSchema[]): number {
  return drawnCards(cards).length
}

// the cards themselves, for a grid that pages them: a display:none card left in a page would take a slot
export function drawnCards(cards: IEcommerceAnswerSchema[]): IEcommerceAnswerSchema[] {
  return cards.filter(card => !card.hidden)
}
